import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * RoleProtectedRoute
 * @param {Object} user - current logged in user object
 * @param {Array} allowedRoles - roles that can access this route
 */
const RoleProtectedRoute = ({ user, allowedRoles, children }) => {
  if (!user) {
    return <Navigate to="/" replace />; // Not logged in
  }

  if (!allowedRoles.includes(user.role)) {
    // Role not allowed → redirect to their own dashboard home
    switch (user.role) {
      case 'admin':
        return <Navigate to="/dashboard/home" replace />;
      case 'staff':
        return <Navigate to="/dashboard/staff-home" replace />;
      case 'student':
        return <Navigate to="/dashboard/student-home" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default RoleProtectedRoute;
